import { Flame, UtensilsCrossed, PawPrint, Trees, Bath, Coffee } from "lucide-react";

const items = [
  {
    icon: Flame,
    title: "Parrilla & fogueira",
    text: "Área gourmet completa com parrilla argentina, chopeira exclusiva e fogueira ao ar livre.",
  },
  {
    icon: UtensilsCrossed,
    title: "Café da manhã e jantar",
    text: "Refeições preparadas com ingredientes da nossa região, inclusas em todas as diárias.",
  },
  {
    icon: Bath,
    title: "Hidro e ofurô",
    text: "Hidromassagem em todas as cabanas. O Domo conta também com ofurô interno e spa externo.",
  },
  {
    icon: Trees,
    title: "Trilhas e morangais",
    text: "Trilhas pela mata e a oportunidade de colher seu próprio morango direto da plantação.",
  },
  {
    icon: PawPrint,
    title: "Pet friendly",
    text: "Seu amigo de quatro patas é muito bem-vindo. Taxa única de R$ 200,00 para higienização.",
  },
  {
    icon: Coffee,
    title: "Conforto rural",
    text: "Cama queen flutuante, ar-condicionado split, Wi-Fi e câmeras de segurança externa.",
  },
];

export const Experiencia = () => {
  return (
    <section
      id="experiencia"
      data-testid="experiencia-section"
      className="bg-[#F2EFE9] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[#5C6661] font-bold mb-6">
              <span className="w-8 h-px bg-[#C05A44]" />
              Experiência
            </span>
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#1A2421] tracking-tighter leading-[1.02]">
              Tudo o que você precisa<br />para desacelerar.
            </h2>
          </div>
          <div className="lg:col-span-7 flex items-end">
            <p className="text-lg text-[#5C6661] leading-relaxed">
              A 30 km do centro de Curitiba, a Quinta foi pensada para quem
              quer trocar a pressa pela natureza. Cada detalhe é cuidado para
              que sua estadia seja memorável — desde o aroma do café da manhã
              até a fogueira ao anoitecer.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E3DCD2] border border-[#E3DCD2]">
          {items.map((it, i) => (
            <div
              key={it.title}
              data-testid={`experiencia-item-${i}`}
              className="bg-[#F9F6F0] p-8 lg:p-10 flex flex-col gap-4 hover:bg-white transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center bg-[#2C5545] text-[#F9F6F0]">
                <it.icon size={20} strokeWidth={1.5} />
              </span>
              <h3 className="text-xl font-bold text-[#1A2421] tracking-tight">
                {it.title}
              </h3>
              <p className="text-sm text-[#5C6661] leading-relaxed">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experiencia;
